
import { isNull } from "../../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AssetLoadService from "../../../../../../../shared/src/ranj/app/assetloading/AssetLoadService";
import AssetLoadServiceEvent from "../../../../../../../shared/src/ranj/app/assetloading/AssetLoadServiceEvent";
import AbstractCommand from "../../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameEvent from "../../../../../../../shared/src/ranj/app/core/GameEvent";
import ProgressValue from "../../../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import SaveEvent from "../../../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameModel from "../../../core/model/GameModel";
import TrackingController from "../../../tracking/controller/TrackingController";
import NGTVariableManager from "../../base/NGTVariableManager";
import NGTScenarioPlayer from "../NGTScenarioPlayer";
import ScenarioLibrary from "../ScenarioLibrary";
import ScenarioPlayerEvent from "../ScenarioPlayerEvent";
import ScenarioPlayerRegisterEvent from "./ScenarioPlayerRegisterEvent";

/**
* PlayScenarioCommand.js
* 
* Created on 2-okt-2013, 16:08:55
*
* @author Ivo Swartjes for Ranj
**/
export default class PlayScenarioCommand extends AbstractCommand {

    /**
     * 
     * @param {*} storyFactory 
     * @param {*} playSessionModel 
     * @param {*} soundManager 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {*} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     * @param {*} assetLocator 
     * @param {NGTVariableManager} variableManager 
     * @param {TrackingController} trackingModel 
     * @param {GameModel} gameModel 
     */
    constructor(storyFactory, playSessionModel, soundManager,
        scenarioLibrary, scenarioPlayer, dispatcher, assetLoadService, assetLocator, variableManager, trackingController, gameModel) {

        super(dispatcher);
        this._scenarioPlayer;
        this._scenarioToPlay;
        this._storyFactory = storyFactory;
        this._playSessionModel = playSessionModel;
        this._scenarioLibrary = scenarioLibrary;
        this._scenarioPlayer = scenarioPlayer;
        this._assetLocator = assetLocator;
        this._assetLoadService = assetLoadService;
        this._variableManager = variableManager;
        this._soundManager = soundManager;
        this._trackingController = trackingController;
        this._gameModel = gameModel;

        this._onScenarioLoaded = this.onScenarioLoaded.bind(this);
        this._onScenarioEnd = this.onScenarioEnd.bind(this);

        this.execute = function(event) {

            this._scenarioToPlay = this._scenarioLibrary.getDefaultScenario();
            if (event.params) {
                this._storyMemento = event.params.storyMemento;
                this._storyVariables = event.params.storyVariables;
                if (event.params.scenarioId) {
                    this._scenarioToPlay = this._scenarioLibrary.getScenarioByID(event.params.scenarioId);
                }
            }

            if (isNull(this._storyMemento)) {
                this.dispatch(SaveEvent.SAVE);
            }

            //TEMP: use default path for localized assets as long as we dont have translations


            // Load scenario assets
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);
            this._assetLoadService.loadGroups(this._scenarioToPlay.id);
            //also add to assetLocator (so DialogEditorGateway can find assets)
            this._assetLocator.addManifest(this._assetLoadService.getManifest(this._scenarioToPlay.id));

            var lazyLoadAssetManifest = this._assetLoadService.getManifest(this._scenarioToPlay.id + "_lazyLoad");
            this._assetLocator.addManifest(lazyLoadAssetManifest);

        };
    }

    onScenarioLoaded(event) {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);

        // Set the current scenario in the library
        this._scenarioLibrary.setCurrentScenario(this._scenarioToPlay);

        // Start a new scenario play session
        this._playSessionModel.startNewScenarioSession(this._scenarioToPlay.id);

        // Create story
        this._scenarioToPlay.story = this._storyFactory.getStory(this._scenarioToPlay.storyID);

        // Initialize scenario 
        // From story memento, if any; else start with clear variable manager
        this._variableManager.reset();
        if (this._storyVariables) {
            this._variableManager.setState(this._storyVariables);
        }
        this._scenarioPlayer.init(this._scenarioToPlay, this._storyMemento);

        this._trackingController.trackProgress(ProgressValue.STARTED);

        var sprEvent = new ScenarioPlayerRegisterEvent(ScenarioPlayerRegisterEvent.REGISTER, this._scenarioPlayer);
        this._dispatcher.dispatch(sprEvent.type, sprEvent);

        // Start the scenario!
        this._startTime = Date.now();
        this._scenarioPlayer.eventDispatcher.addEventListener(ScenarioPlayerEvent.SCENARIO_END, this._onScenarioEnd);
        this._scenarioPlayer.play();
    }

    onScenarioEnd(event) {
        this._gameModel.completed = true;

        //wait 1 frame before tracking progress, to avoid dialog completion to be sent later then overall completion (due to order of eventlisteners)
        setTimeout(() => { this._trackingController.trackProgress(ProgressValue.COMPLETED); });

        var sprEvent = new ScenarioPlayerRegisterEvent(ScenarioPlayerRegisterEvent.DEREGISTER, this._scenarioPlayer);
        this._dispatcher.dispatch(sprEvent.type, sprEvent);

        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);
        this._scenarioPlayer.eventDispatcher.removeEventListener(ScenarioPlayerEvent.SCENARIO_END, this._onScenarioEnd);
        this._scenarioPlayer.stop();

        this.dispatch(GameEvent.COMPLETED);
    }

}

